import { FontSizeData_fontType } from "./decoration_fontsize.enums";
function fontSizeData_fontTypeFromJSON(object) {
  switch (object) {
    case 0:
    case "PX":
      return FontSizeData_fontType.PX;
    case 1:
    case "EM":
      return FontSizeData_fontType.EM;
    case -1:
    case "UNRECOGNIZED":
    default:
      return FontSizeData_fontType.UNRECOGNIZED;
  }
}
function fontSizeData_fontTypeToJSON(object) {
  switch (object) {
    case FontSizeData_fontType.PX:
      return "PX";
    case FontSizeData_fontType.EM:
      return "EM";
    default:
      return "UNKNOWN";
  }
}
const baseFontSizeData = { unit: FontSizeData_fontType.PX };
const FontSizeData = {
  fromJSON(object) {
    const message = { ...baseFontSizeData };
    message.unit = object.unit !== void 0 && object.unit !== null ? fontSizeData_fontTypeFromJSON(object.unit) : FontSizeData_fontType.PX;
    message.value = object.value !== void 0 && object.value !== null ? Number(object.value) : void 0;
    return message;
  },
  toJSON(message) {
    const obj = {};
    message.unit !== void 0 && (obj.unit = fontSizeData_fontTypeToJSON(message.unit));
    message.value !== void 0 && (obj.value = message.value);
    return obj;
  }
};
export {
  FontSizeData,
  fontSizeData_fontTypeFromJSON,
  fontSizeData_fontTypeToJSON
};
//# sourceMappingURL=decoration_fontsize.js.map
